module.exports = __webpack_public_path__ + "static/media/DTBH01.44fa45f3.jpg";